import request from '@/utils/request'

// Customer List
export function getCustomerList(param) {
  let data = param
  return request({
    url: `/zdmin/admZ010/getCustomerList`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
}